const prefersReducedMotion = window.matchMedia(
  "(prefers-reduced-motion: reduce)",
).matches;
const gsapInstance = window.gsap;

if (
  gsapInstance &&
  !prefersReducedMotion &&
  window.matchMedia("(hover: hover) and (pointer: fine)").matches
) {
  // Add hover-driven description reveals for project cards.
  document.querySelectorAll(".sp-project-card").forEach((card) => {
    const description = card.querySelector(".sp-project-card__description");
    if (!description) return;

    gsapInstance.set(description, { autoAlpha: 0, y: 6 });

    // Reveal project description on hover.
    card.addEventListener("mouseenter", () => {
      gsapInstance.to(description, {
        autoAlpha: 1,
        y: 0,
        duration: 0.15,
        ease: "power2.out",
      });
    });

    // Hide project description when leaving.
    card.addEventListener("mouseleave", () => {
      gsapInstance.to(description, {
        autoAlpha: 0,
        y: 6,
        duration: 0.15,
        ease: "power2.out",
      });
    });
  });
}

if (window.matchMedia("(hover: hover) and (pointer: fine)").matches) {
  const projectCards = Array.from(
    document.querySelectorAll(".sp-project-card"),
  );
  // Track only cards with MP4 previews for dimming.
  const videoCards = projectCards.filter((card) =>
    card.querySelector(".sp-project-card__image video"),
  );

  if (projectCards.length && videoCards.length) {
    // Pause a preview video if present in the card.
    const pauseVideo = (card) => {
      const video = card.querySelector(".sp-project-card__image video");
      if (video) video.pause();
    };

    // Resume a preview video if present in the card.
    const playVideo = (card) => {
      const video = card.querySelector(".sp-project-card__image video");
      // Ignore autoplay errors for muted previews.
      if (video) video.play().catch(() => {});
    };

    // Reset dimming and restore playback for all video cards.
    const clearDimmedState = () => {
      videoCards.forEach((card) => {
        card.classList.remove("sp-project-card--dimmed");
        playVideo(card);
      });
    };

    // Bind hover handlers for dimming and playback control.
    projectCards.forEach((card) => {
      // Dim other video cards while hovering a card.
      card.addEventListener("mouseenter", () => {
        // Dim every other video card while hovering.
        videoCards.forEach((item) => {
          if (item === card) {
            item.classList.remove("sp-project-card--dimmed");
            playVideo(item);
            return;
          }
          item.classList.add("sp-project-card--dimmed");
          pauseVideo(item);
        });
      });

      // Restore all cards when leaving.
      card.addEventListener("mouseleave", clearDimmedState);
    });
  }
}
